import React from 'react';
import PropTypes from 'prop-types';
import styled from "@emotion/styled";
import {IconButton} from "@material-ui/core";
import Icon from "@material-ui/core/Icon";

const NotificationWrapper = styled.div`
    width: 342px;
    min-height: 110px;
    height: fit-content;
    
    /* default/shade/white */
    background: #FFFFFF;
    /* default/gray/300 */
    border: 1px solid #E2E8F0;
    box-sizing: border-box;
    border-radius: 8px;
    padding: 8px;
    overflow: hidden;
`;


const HeadingSection = styled.div`
    display: flex;
    justify-content: space-between;
    
    /* text-sm/Light */
    font-family: Metropolis;
    font-style: normal;
    font-weight: 300;
    font-size: 14px;
    line-height: 14px;
    /* identical to box height, or 100% */
    align-items: center;
    
    /* default/gray/500 */
    color: var(--color-gray-500)
`;

const NotificationContent = styled.div`
    margin: 10px 0;
    height: fit-content;
    overflow: scroll;
    
    font-family: Metropolis;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    /* or 150% */
    
    /* default/gray/700 */
    color: var(--color-gray-700);
    text-overflow: ellipsis;
`;

const HeadingWrapper = styled.div`
    display: flex;
    flex-direction: row;
    
    > * {
      margin-right: 8px;
    }
`;


function NotificationPanelItem({heading, icon, content, timeCreated, onClose}) {
    return (
        <NotificationWrapper>
            <HeadingSection>
                <HeadingWrapper>
                    <div>{icon}</div>
                    {heading}
                </HeadingWrapper>

                <span>
                    {timeCreated}
                    <IconButton size="small" onClick={onClose}>
                        <Icon fontSize="small">close</Icon>
                    </IconButton>
                </span>
            </HeadingSection>

            <NotificationContent>
                {content}
            </NotificationContent>
        </NotificationWrapper>
    );
}

NotificationPanelItem.propTypes = {};
NotificationPanelItem.defaultProps = {};

export default NotificationPanelItem;
